import {goBack} from '~/routing/actions'
import {LegacyFormModal} from '~/components'
import {Environment, Organisation} from '@eitje/api'
import {date} from '@eitje/utils'
import {FormFields} from './form_fields'

const FREE_TRIAL_DAYS = 28

export const NewEnvironment = () => {
	const handleSubmit = async params => {
		const result = await Environment.create(params)
		if (result.ok) Organisation.index()
		return result
	}

	return (
		<LegacyFormModal
			name="create_environment"
			onSubmit={handleSubmit}
			afterSubmit={goBack}
			modalProps={{
				okButtonProps: {t: 'common.create'},
			}}
			initialValues={{status: 'active', strategy: 'new', first_billing_date: getDefaultBillingDate()}}
			width={400}
		>
			<FormFields />
		</LegacyFormModal>
	)
}

function getDefaultBillingDate() {
	const today = date()
	const billingDate = today.add(FREE_TRIAL_DAYS, 'days')
	return billingDate.format()
}
